import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './About.css';

function About() {
  return (
    <div className="about-page">
      <Helmet>
        <title>Notre Agence | E-Shop Pro - Création de Sites et Applications</title>
        <meta name="description" content="E-Shop Pro, agence digitale à Paris spécialisée dans la création de sites web et applications mobiles sur mesure pour les professionnels." />
      </Helmet>
      
      <section className="about-hero">
        <div className="container">
          <h1>Votre partenaire digital à <span className="gradient-text">Paris</span></h1>
          <p>E-Shop Pro accompagne les professionnels dans leur transformation digitale depuis plus de 10 ans</p>
        </div>
      </section>
      
      <section className="container section">
        <div className="about-grid">
          <div className="about-content">
            <h2>Qui sommes-nous ?</h2>
            <p>
              <strong>E-Shop Pro</strong> est une agence digitale basée en Île-de-France, spécialisée dans la création 
              de solutions numériques sur mesure pour les professionnels.
            </p>
            <p>
              Que vous soyez coiffeur, restaurateur, médecin ou commerçant, nous concevons des sites web, 
              applications mobiles et outils de gestion qui correspondent exactement à vos besoins.
            </p>
            <p>
              Notre approche : comprendre votre métier, vos clients, vos objectifs, puis créer la solution 
              digitale qui vous permettra de vous démarquer et de développer votre activité.
            </p>
          </div>
          
          <div className="about-stats">
            <div className="stat-card">
              <span className="stat-icon">🚀</span>
              <span className="stat-number">50+</span>
              <span className="stat-label">Projets réalisés</span>
            </div>
            <div className="stat-card">
              <span className="stat-icon">⭐</span>
              <span className="stat-number">10+</span>
              <span className="stat-label">Années d'expérience</span>
            </div>
            <div className="stat-card">
              <span className="stat-icon">💯</span>
              <span className="stat-number">100%</span>
              <span className="stat-label">Clients satisfaits</span>
            </div>
            <div className="stat-card">
              <span className="stat-icon">🇫🇷</span>
              <span className="stat-number">IDF</span>
              <span className="stat-label">Basés à Paris</span>
            </div>
          </div>
        </div>
      </section>
      
      <section className="services-section">
        <div className="container">
          <h2 className="section-title">Nos services</h2>
          <div className="services-grid">
            <div className="service-card">
              <span className="service-icon">🌐</span>
              <h3>Sites Web</h3>
              <p>Sites vitrines, e-commerce, landing pages. Design moderne et optimisé SEO.</p>
            </div>
            <div className="service-card">
              <span className="service-icon">📱</span>
              <h3>Applications Mobiles</h3>
              <p>Apps iOS et Android, PWA. Expérience utilisateur optimale.</p>
            </div>
            <div className="service-card">
              <span className="service-icon">📅</span>
              <h3>Réservation en ligne</h3>
              <p>Systèmes de RDV, planning, notifications automatiques.</p>
            </div>
            <div className="service-card">
              <span className="service-icon">💼</span>
              <h3>Logiciels Métier</h3>
              <p>CRM, ERP, outils de gestion sur mesure pour votre activité.</p>
            </div>
          </div>
        </div>
      </section>
      
      <section className="cta-section">
        <div className="container">
          <div className="cta-card">
            <h2>Prêt à digitaliser votre activité ?</h2>
            <p>Discutons de votre projet. Première consultation gratuite et sans engagement.</p>
            <Link to="/contact" className="btn btn-primary">
              Demander un devis gratuit
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
